import EventEmitter from 'events'

class Storage extends EventEmitter {
  getItem<T>(keyName: string): T {
    const valueFromStore = window.localStorage.getItem(keyName)

    if (valueFromStore === null || valueFromStore === undefined) {
      return null
    }

    const parsedValue = JSON.parse(valueFromStore)

    return parsedValue.value
  }

  setItem(keyName: string, keyValue: unknown) {
    const valueToStore = {
      value: keyValue,
    }

    window.localStorage.setItem(keyName, JSON.stringify(valueToStore))

    this.emit(keyName, keyValue)
  }

  removeItem(keyName: string) {
    window.localStorage.removeItem(keyName)
  }

  clear() {
    window.localStorage.clear()
  }
}

export const storage = new Storage()
